import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import moment from 'moment';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';
import Avatar from 'components/atoms/avatar';
import Button from 'components/atoms/button';
import FormContent from 'components/organisms/formContent';
import FormActions from 'components/molecules/formActions';
import FormCol from 'components/molecules/formCol';
import FormCardSelect from 'components/molecules/formCardSelect/index.jsx';
import WizardProgress from 'components/organisms/wizard/progress';
import { fetchTimesheet } from 'actions/models';
import { buildRequestObject } from 'helpers/vehicle';
import validate from '../validate';

class AdvisorSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      initialized: false,
    };
  }

  update() {
    const { vehicle, engine, transmission, traction, services, date, workshop } = this.props;

    const attributes = buildRequestObject({
      vehicle,
      engine,
      transmission,
      traction,
      services,
      date,
      workshop,
    });

    this.props.fetchTimesheet(attributes, this.props.brandId);
  }

  componentDidMount() {
    if (!this.state.initialized) {
      this.update();

      this.state.initialized = true;
    }
  }

  render() {
    const { timesheet, advisor, handleSubmit, date, hour, worker } = this.props;

    const momentDate = moment(date);

    return (
      <div className="advisorSelect">
        <Header inFlow />
        <WizardProgress step="5" />
        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Selecciona el asesor de servicio</h2>
              <p className="m">
                Elegí el asesor que te atenderá el {momentDate.format('dddd DD')} a las {hour}.
              </p>
              <form onSubmit={handleSubmit}>
                <FormContent nomargins>
                  <FormCol single scrolleable cardList>
                    {timesheet &&
                      timesheet.advisors &&
                      timesheet.advisors.map((advisor, i) => {
                        if (advisor.timesheet.indexOf(hour) < 0) {
                          return;
                        }

                        return (
                          <Field
                            component={FormCardSelect}
                            name="advisor"
                            key={i}
                            props={{ fieldValue: advisor }}
                          >
                            <div>
                              <Avatar
                                imageUrl={'http://territorioyacopini.com.ar' + advisor.image}
                                initials={advisor.name.split('')[0] + advisor.lastname.split('')[0]}
                              />
                              <h5>
                                {advisor.name} {advisor.lastname}
                              </h5>
                            </div>
                          </Field>
                        );
                      })}
                    {timesheet &&
                      timesheet.workers &&
                      timesheet.workers.map((worker, i) => {
                        if (worker.available_hours.indexOf(hour) < 0) {
                          return;
                        }

                        return (
                          <Field
                            component={FormCardSelect}
                            name="worker"
                            key={i}
                            props={{ fieldValue: worker }}
                          >
                            <div>
                              <Avatar
                                imageUrl={'http://territorioyacopini.com.ar' + worker.image}
                                initials={worker.name.split('')[0] + worker.lastname.split('')[0]}
                              />
                              <h5>
                                {worker.name} {worker.lastname}
                              </h5>
                            </div>
                          </Field>
                        );
                      })}
                  </FormCol>

                  <FormActions back={this.props.previousPage}>
                    <Button type="submit" buttonText="Continuar" disabled={!advisor && !worker} />
                  </FormActions>
                </FormContent>
              </form>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

AdvisorSelect = reduxForm({
  form: 'shiftRequest',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(AdvisorSelect);

const selector = formValueSelector('shiftRequest');

AdvisorSelect = connect(state => {
  return {
    vehicle: selector(state, 'vehicle'),
    engine: selector(state, 'engine'),
    transmission: selector(state, 'transmission'),
    traction: selector(state, 'traction'),
    services: selector(state, 'services'),
    is_under_warranty: selector(state, 'is_under_warranty'),
    date: selector(state, 'date'),
    hour: selector(state, 'hour'),
    workshop: selector(state, 'workshop'),
    advisor: selector(state, 'advisor'),
    worker: selector(state, 'worker'),
    brandId: state.configuration.brand_id,
  };
})(AdvisorSelect);

const mapStateToProps = state => {
  return {
    timesheet: state.models.timesheet,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchTimesheet: (attributes, brandId) => {
      dispatch(fetchTimesheet(attributes, brandId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdvisorSelect);
